import React, { useState } from 'react';
import { Box, TextField, IconButton, useMediaQuery, useTheme } from '@mui/material';
import SendIcon from '@mui/icons-material/SendRounded';

const MessageInput = ({ onSendMessage }) => {
  const [message, setMessage] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim()) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: 'flex', // none
        alignItems: 'center',
        gap: { xs: 0.5, sm: 1 },
        p: { xs: 1.5, sm: 2 },
        backgroundColor: '#fff',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
      }}
    >
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Type your message..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyPress={handleKeyPress}
        multiline
        maxRows={4}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            backgroundColor: '#f5f5f5',
            fontSize: { xs: '0.875rem', sm: '1rem' },
          }
        }}
      />
      <IconButton
        type="submit"
        disabled={!message.trim()}
        sx={{
          backgroundColor: message.trim() ? '#9D1680' : 'action.disabledBackground',
          color: message.trim() ? '#fff' : 'action.disabled',
          '&:hover': {
            backgroundColor: message.trim() ? '#9D1680' : 'action.disabledBackground',
          },
          width: { xs: 36, sm: 40 },
          height: { xs: 36, sm: 40 },
        }}
      >
        <SendIcon fontSize={isMobile ? "small" : "medium"} />
      </IconButton>
    </Box>
  );
};

export default MessageInput;